import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// 드롭다운 방식으로 다시 변경 - 홈과 유사한 스타일
const MobileContainer = styled.div`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  background: #ffffff;
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;


const MobileContent = styled.main`
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  padding-top: 130px; /* FilterBar + 검색 컨테이너 고려 */
  min-height: calc(100vh - 60px);
  background: white;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  
  * {
    max-width: 100%;
    box-sizing: border-box;
  }
`;


const FilterBar = styled.div`
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 100%;
  padding: 0.75rem;
  margin: 0;
  background: white;
  border-bottom: 1px solid #e9ecef;
  z-index: 10;
  box-sizing: border-box;
  
  @media (min-width: 769px) {
    display: none;
  }
  
`;

const FilterButton = styled.button`
  width: 100%;
  max-width: 100%;
  padding: 0.875rem 1rem;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0;
  color: #495057;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background: #f8f9fa;
    border-color: #adb5bd;
  }
  
  .text {
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .arrow {
    font-size: 1.2rem;
    transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 0.3s ease;
    flex-shrink: 0;
    margin-left: 0.5rem;
  }
`;

const DropdownOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 50;
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
`;

const DropdownMenu = styled.div`
  position: fixed;
  top: 133px; /* FilterBar 아래 */
  left: 0.75rem;
  right: 0.75rem;
  max-height: 60vh;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 100;
  overflow-y: auto;
  transform: ${props => props.isOpen ? 'translateY(0)' : 'translateY(-10px)'};
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: all 0.2s ease;
`;

const DropdownHeader = styled.div`
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
  
  h3 {
    color: #495057;
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
  }
`;

const DropdownSection = styled.div`
  max-height: 50vh;
  overflow-y: auto;
`;

const DropdownItem = styled.div`
  padding: 1rem;
  color: ${props => props.active ? '#007bff' : '#495057'};
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${props => props.active ? '#e3f2fd' : 'transparent'};
  border-bottom: 1px solid #f0f0f0;
  
  &:hover {
    background: #f8f9fa;
    color: #007bff;
  }
  
  &:last-child {
    border-bottom: none;
  }
  
  .label {
    font-size: 1rem;
    font-weight: 500;
  }
`;

const BackButton = styled.div`
  padding: 0.75rem 1rem;
  margin: 0.5rem;
  border-radius: 10px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    color: dodgerblue;
  }
  
  .arrow {
    color: white;
    font-size: 0.9rem;
  }
  
  .text {
    font-size: 0.85rem;
    color: white;
    font-weight: 500;
  }
`;

const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 0.25rem 0;
`;

const MobileSubNavigator = (props) => {
  
  const { 
    links = [], 
    sectionTitle = "메뉴", 
    children,
    showBackButton = true,
    backPath = "/"
  } = props;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  // links prop 변화 추적 및 강제 리렌더링
  useEffect(() => {
    // 강제 리렌더링
    setForceUpdate(prev => prev + 1);
  }, [links, sectionTitle]);

  const handleNavigate = (path) => {
    navigate(path);
    setDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const handleBack = () => {
    navigate(backPath);
    setDropdownOpen(false);
  };

  // 현재 활성화된 메뉴 찾기
  const activeLink = links.find(link => location.pathname === link.path);
  const displayText = activeLink ? activeLink.label : `${sectionTitle} 선택`;

  return (
    <MobileContainer>
      {/* 상단 필터 바 */}
      <FilterBar>
        <FilterButton isOpen={dropdownOpen} onClick={toggleDropdown}>
          <span className="text">{displayText}</span>
          <span className="arrow">▼</span>
        </FilterButton>
      </FilterBar>

      {/* 드롭다운 오버레이 */}
      <DropdownOverlay isOpen={dropdownOpen} onClick={closeDropdown} />
      
      {/* 드롭다운 메뉴 */}
      <DropdownMenu isOpen={dropdownOpen}>
        <DropdownHeader>
          <h3>{sectionTitle}</h3>
        </DropdownHeader>
        
        
        <DropdownSection>
          {Array.isArray(links) ? links.filter(link => link && link.path && link.label).map((link, index) => (
            <DropdownItem
              key={`${link.path}-${index}`}
              active={location.pathname === link.path}
              onClick={() => handleNavigate(link.path)}
            >
              <div className="label">{link.label}</div>
            </DropdownItem>
          )) : null}
          {(!Array.isArray(links) || links.length === 0) && (
            <DropdownItem>
              <div className="label" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>메뉴를 불러오는 중...</div>
            </DropdownItem>
          )}
        </DropdownSection>
      </DropdownMenu>

      <MobileContent>
        {children}
      </MobileContent>
    </MobileContainer>
  );
};

export default MobileSubNavigator;